import { radioClasses } from "@mui/material";
import { color } from "@mui/system";

export default function componentStyleOverrides(theme: any) {
    const bgColor = theme.colors?.grey50;
    return {
        MuiTextField: {
            styleOverrides: {
                root: {
                    // backgroundColor: "var(--ion-color-dark)",
                    "& input": {
                        color: "var(--color-white)",
                    },
                    "& > label": {
                        color: theme.grey500,
                    },
                    "& .MuiInputBase-root": {
                        backgroundColor: "var(--ion-color-dark)",
                    },
                    "& .MuiInputBase-input": {
                        backgroundColor: "unset",
                        color: "var(--color-white)",
                    },
                    "& fieldset": {
                        borderColor: "var(--ion-color-grey)",
                    },
                },
            },
        },
        MuiPopover: {
            styleOverrides: {
                root: {
                    "& .MuiPaper-root": {
                        backgroundColor: "var(--ion-color-medium)",
                    },
                },
            },
        },
        MuiTextarea: {
            styleOverrides: {
                root: {
                    // backgroundColor: "var(--ion-color-dark)",
                    "& input": {
                        color: "var(--color-white)",
                    },
                    "& > label": {
                        color: theme.grey500,
                    },
                    "& .MuiInputBase-root": {
                        backgroundColor: "var(--ion-color-dark)",
                    },
                    "& .MuiInputBase-input": {
                        backgroundColor: "unset",
                        color: "var(--color-white)",
                    },
                    "& fieldset": {
                        borderColor: "var(--ion-color-grey)",
                    },
                },
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    paddingLeft: "14px",
                    "@media (min-width: 600px)": {
                        paddingLeft: "14px",
                    },
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    color: "white",
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    marginInline: 0,
                    marginBottom: 0,
                    padding: 0,
                },
            },
        },

        MuiSelect: {
            styleOverrides: {
                select: {
                    color: "var(--ion-color-light)",
                },
                icon: {
                    color: "var(--filter-grey)", // Change color
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                root: {
                    "& .MuiDialog-container": { backdropFilter: "blur(5px)" },
                    "& .MuiPaper-root": {
                        boxShadow: "var(--ion-color-dark) 0 0 26px -2px",
                        background: "var(--color-black)",
                        borderRadius: "var(--border-radius-section)",
                        maxWidth: "650px",
                        width: "calc(100% - 32px)",
                        margin: "32px", // Default margin,
                        padding: "2rem",
                        "@media (max-width:700px)": {
                            margin: "16px", // Margin for screens 700px and wider
                            padding: "1rem",
                        },
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontSize: "1.5rem",
                    color: "var(--color-white)",
                    fontWeight: 600,
                    paddingInline: 0,
                    paddingTop: 0,
                    "@media (max-width:700px)": {
                        paddingLeft: "0px", // Margin for screens 700px and wider
                        paddingRight: "0px", // Margin for screens 700px and wider
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingInline: 0,
                    "@media (max-width:700px)": {
                        paddingLeft: "0px", // Margin for screens 700px and wider
                        paddingRight: "0px", // Margin for screens 700px and wider
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                    borderRadius: "8px",
                    "&:hover": {
                        backgroundColor: "var(--ion-color-primary-shade)",
                    },
                    "&.Mui-disabled": {
                        backgroundColor: "var(--ion-color-primary-30)", // Custom background color
                        // color: "#dadada", // Custom text color
                    },
                },
                outlined: {
                    "&:hover": {
                        color: "black",
                    },
                },
                text: {
                    "&:hover": {
                        color: "black",
                    },
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                root: {
                    backgroundImage: "none",
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: "24px",
                },
                title: {
                    fontSize: "1.125rem",
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: "24px",
                },
            },
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: "24px",
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.colors?.text,
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    "& .MuiListItemIcon-root": {
                        color: theme.colors?.text,
                    },

                    // "&.Mui-selected": {
                    //     color: theme.menuSelected,
                    //     backgroundColor: theme.menuSelectedBack,
                    //     "&:hover": {
                    //         backgroundColor: theme.menuSelectedBack,
                    //     },
                    //     "& .MuiListItemIcon-root": {
                    //         color: theme.menuSelected,
                    //     },
                    // },

                    "&:hover": {
                        backgroundColor: theme.colors?.mediumOrange,
                        color: theme.colors?.paper,
                        "& .MuiListItemIcon-root": {
                            color: theme.colors?.paper,
                        },
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: "var(--color-white)",
                    minWidth: "36px",
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: "var(--color-white)",
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    "&::placeholder": {
                        color: theme.darkTextSecondary,
                        fontSize: "0.875rem",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: bgColor,
                    borderRadius: "12px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: theme.colors?.grey400,
                    },
                    "&:hover $notchedOutline": {
                        borderColor: theme.colors?.primaryLight,
                    },
                    "&.MuiInputBase-multiline": {
                        padding: 1,
                    },
                },
                input: {
                    fontWeight: 500,
                    background: bgColor,
                    padding: "15.5px 14px",
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    "&.MuiInputBase-inputSizeSmall": {
                        padding: "10px 14px",
                        "&.MuiInputBase-inputAdornedStart": {
                            paddingLeft: 0,
                        },
                    },
                },
                inputAdornedStart: {
                    paddingLeft: 4,
                },
                notchedOutline: {
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        color: theme.colors?.grey300,
                    },
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: "4px",
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight,
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: "var(--ion-color-medium)",
                    opacity: 1,
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200,
                    svg: {
                        color: theme.colors?.mediumOrange,
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    "&.MuiChip-deletable .MuiChip-deleteIcon": {
                        color: "inherit",
                    },
                    "&.MuiChip-colorDefault": {
                        backgroundColor: "var(--ion-color-medium)",
                    },
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                arrow: true,
                enterDelay: 250,
            },
            styleOverrides: {
                tooltip: {
                    color: "#F5F1E8",
                    backgroundColor: "#1F1A17",
                    border: "1px solid rgba(255, 184, 0, 0.22)",
                    borderRadius: "10px",
                    padding: "10px 12px",
                    fontSize: "0.78rem",
                    fontWeight: 500,
                    lineHeight: 1.4,
                    boxShadow: "0 10px 24px rgba(0, 0, 0, 0.28)",
                    maxWidth: "260px",
                },
                arrow: {
                    color: "#1F1A17",
                },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                root: {
                    width: 42,
                    height: 26,
                    padding: 0,
                    "& .MuiSwitch-switchBase": {
                        padding: 0,
                        margin: 2,
                        transitionDuration: "300ms",
                        "&.Mui-checked": {
                            transform: "translateX(16px)",
                            color: "#fff",
                            "& + .MuiSwitch-track": {
                                backgroundColor: "var(--ion-color-primary)",
                                opacity: 1,
                                border: 0,
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                                opacity: 0.5,
                            },
                        },
                        "&.Mui-focusVisible .MuiSwitch-thumb": {
                            border: "6px solid #fff",
                        },
                        "&.Mui-disabled .MuiSwitch-thumb": {
                            color: "var(--ion-color-grey)",
                        },
                        "&.Mui-disabled + .MuiSwitch-track": {
                            opacity: 0.7,
                        },
                    },
                    "& .MuiSwitch-thumb": {
                        boxSizing: "border-box",
                        width: 22,
                        height: 22,
                    },
                    "& .MuiSwitch-track": {
                        borderRadius: 26 / 2,
                        backgroundColor: "var(--ion-color-light)",
                        opacity: 1,
                    },
                },
            },
        },
    };
}
